import {
  FaStar, FaCrown, FaFire, FaBolt, FaGem, FaTrophy, FaRocket, FaHeart,
  FaShield, FaMedal, FaWandMagicSparkles, FaMoon, FaSun, FaLeaf, FaPaw, FaGhost,
} from "react-icons/fa6";

// Curated on purpose (rather than free-text/upload): keeps every custom
// badge visually consistent with the built-in ones and avoids needing an
// image-upload/moderation pipeline just for a small chip icon.
export const BADGE_ICONS = {
  star: { label: "Star", Icon: FaStar },
  crown: { label: "Crown", Icon: FaCrown },
  fire: { label: "Fire", Icon: FaFire },
  bolt: { label: "Bolt", Icon: FaBolt },
  gem: { label: "Gem", Icon: FaGem },
  trophy: { label: "Trophy", Icon: FaTrophy },
  rocket: { label: "Rocket", Icon: FaRocket },
  heart: { label: "Heart", Icon: FaHeart },
  shield: { label: "Shield", Icon: FaShield },
  medal: { label: "Medal", Icon: FaMedal },
  sparkles: { label: "Sparkles", Icon: FaWandMagicSparkles },
  moon: { label: "Moon", Icon: FaMoon },
  sun: { label: "Sun", Icon: FaSun },
  leaf: { label: "Leaf", Icon: FaLeaf },
  paw: { label: "Paw", Icon: FaPaw },
  ghost: { label: "Ghost", Icon: FaGhost },
};

export const BADGE_ICON_KEYS = Object.keys(BADGE_ICONS);

// A small, friendly preset palette — the admin can still type any hex value,
// this is just a fast-path so most people never need to.
export const BADGE_COLOR_PRESETS = [
  "#f43f5e", "#f97316", "#eab308", "#22c55e", "#14b8a6",
  "#0ea5e9", "#6366f1", "#a855f7", "#ec4899", "#64748b",
];
